import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=5dbbe8e4&scoped=true&"
import script from "./AppPage.vue?vue&type=script&lang=js&"
export * from "./AppPage.vue?vue&type=script&lang=js&"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=5dbbe8e4&prod&lang=scss&scoped=true&"
import style1 from "./AppPage.vue?vue&type=style&index=1&id=5dbbe8e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbbe8e4",
  null
  
)

export default component.exports